
import { DOCUMENT, inject, Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { NOOP } from '@libs/classes/utils';
import { filter } from 'rxjs';
import { BrowserService } from './browser.service';

const isNavigationEnd = ($_:unknown):$_ is NavigationEnd => $_ instanceof NavigationEnd
@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  readonly NOOP = NOOP;
  readonly document = inject(DOCUMENT);
  readonly head = this.document.head;
  readonly router = inject(Router);
  readonly browser = inject(BrowserService);
  readonly route = inject(ActivatedRoute);
  readonly navigationEnd$ = this.router.events.pipe( filter( isNavigationEnd ) );
  //
  navigate(commands: string | any[], extras?: NavigationExtras, route?: ActivatedRoute) {
    if (typeof commands === 'string') { commands = [commands]; }
    if(route) extras = {relativeTo: route ?? this.route,...extras};
    return this.router.navigate(commands, extras);
  }
  //
  setTitle = ($_:string) => this.browser.setTitle($_);
}
